import React, { useEffect, useContext } from "react";
import liff from "@line/liff";
import useUsers from "../../hooks/useUsers";
import useAuth from "../../hooks/useAuth";
import AppContext from "../../AppContext";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

const lineClientId = import.meta.env.LINE_CLIENT_ID;
const lineLinkClientId = import.meta.env.LINE_LINK_CLIENT_ID;

const Line = ({ onNavigate, mode }) => {
  const externalType = "line";
  const { queryUsers, patchUser } = useUsers();
  const { signInExternal } = useAuth();

  const { setToken, isAuth, user } = useContext(AppContext);

  useEffect(() => {
    if (mode === "auth") {
      liff.init({ liffId: lineClientId }).then(() => {
        handleLineCallBack();
      });
      return;
    }

    liff.init({ liffId: lineLinkClientId }).then(() => {
      handleLineLinkCallBack();
    });
  }, []);

  useEffect(() => {
    if (!isAuth) return;
    // navigate("/home");
  }, [isAuth]);

  const handleLineCallBack = async () => {
    try {
      const profile = await liff.getProfile();
      const findUser = await queryUsers({ lineId: profile.userId });
      if (findUser.data.length === 0) {
        localStorage.setItem(
          "onboard:credentials",
          JSON.stringify({
            lineId: profile.userId,
            lineAvatar: profile.pictureUrl,
          })
        );
        localStorage.setItem("onboard:registration-id", "line");

        onNavigate("/onboard");
        return;
      }

      const token = await signInExternal(profile.userId, externalType);
      setToken(token);
    } catch (error) {
      toast.error("Line Proile Error");
    }
  };

  const handleLineLinkCallBack = async () => {
    try {
      const profile = await liff.getProfile();
      const findUser = await queryUsers({ lineId: profile.userId });
      if (findUser.data.length !== 0) {
        toast.error("LineId already exist");
        onNavigate("/profile/edit");
        return;
      }

      if (!user._id) {
        toast.error("User on patch data not found");
        onNavigate("/profile/edit");
      }

      await patchUser(user._id, { lineId: profile.userId });
      onNavigate("/profile/edit");
    } catch (error) {
      toast.error("Line Profile Error");
    }
  };
};

Line.propTypes = {};

export default Line;
